import React from "react";
import { UpgradeButton } from "@fidget/common/components/button/upgradeButton";
import { TooltipComponent } from "@fidget/common/components/tooltipComponent";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "./notesLimit.css";

export const NotesLimit: React.SFC = () => (
  <div className={styles["upgrade-button-container"]}>
    <TooltipComponent text={intl.formatMessage("plan.upgrade.history")} positionPreset={"top"}>
      <UpgradeButton text={intl.formatMessage("plan.upgrade.notes.cta")} />
    </TooltipComponent>
  </div>
);
